import React from 'react';

import TopPanelLink from './TopPanelLink';
import PhoneLink from './PhoneLink';
import { TopPanelRightSideProps } from './types';

const TopPanelRightSide: React.FC<TopPanelRightSideProps> = ({ ergeonUrl }) => {
  return (
    <div className="hidden md:flex items-center gap-2">
      <TopPanelLink href={`${ergeonUrl}/gallery`}>Gallery</TopPanelLink>
      <TopPanelLink href={`${ergeonUrl}/fences`}>Fences</TopPanelLink>
      <TopPanelLink href={`${ergeonUrl}/help`}>Help</TopPanelLink>
      <PhoneLink />
    </div>
  );
};

export default TopPanelRightSide;
